module.exports = __webpack_public_path__ + "img/t_0027.10fdaea5.gif";